import React from "react";
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Divider,
  Icon,
  DatePicker,
  Select,
  Switch,
  Skeleton,
} from "antd";
import axios from "axios";
import { withRouter, Redirect } from "react-router-dom";
import moment from "moment";
import { get } from "lodash";
import { withTranslation } from "react-i18next";
import SelectQuery from "../../Lib/SelectQuery";
import Lib from "../../Lib/Utils";
import "./style.css";

const FormItem = Form.Item;
const { Option } = Select;
const dateFormat = "YYYY-MM-DD";

class LeadFormInit extends React.Component {
  state = {
    loading: true,
    tags: [],
    users: [],
    contacts: [],
    country_list: undefined,
    status_list: undefined,
    advertising_list: [],
    source_list: undefined,
  };

  componentDidMount() {
    let token = localStorage.getItem("token");
    axios.defaults.xsrfCookieName = "csrftoken";
    axios.defaults.xsrfHeaderName = "X_CSRFTOKEN";
    axios.defaults.headers = {
      "Content-Type": "application/json",
      "Accept-Language": localStorage.getItem("language"),
      Authorization: `Token ${token}`,
    };

    this.fetch();
  }

  fetch = (e) => {
    let requestList = [];
    requestList.push(axios.get(process.env.REACT_APP_AXIOS_URL + "/api/tags/"));
    requestList.push(
      axios.get(process.env.REACT_APP_AXIOS_URL + "/api/users_list/")
    );
    requestList.push(
      axios.get(
        process.env.REACT_APP_AXIOS_URL + "/api/choice_lead_advertising_list/"
      )
    );
    // requestList.push(axios.get(process.env.REACT_APP_AXIOS_URL + "/api/contacts_list/"));
    if (this.props.requestType === "post") {
      requestList.push(
        axios.get(process.env.REACT_APP_AXIOS_URL + "/api/choice_country_list/")
      );
      requestList.push(
        axios.get(
          process.env.REACT_APP_AXIOS_URL + "/api/choice_lead_status_list/"
        )
      );
      requestList.push(
        axios.get(
          process.env.REACT_APP_AXIOS_URL + "/api/choice_lead_source_list/"
        )
      );
    }

    axios
      .all(requestList)
      .then(
        axios.spread((...responses) => {
          const responseTags = responses[0];
          const responseUsers = responses[1];
          const responseAdvertising = responses[2];
          // const responseContacts = responses[2];
          if (this.props.requestType === "post") {
            const responseCountry = responses[3];
            const responseStatus = responses[4];
            const responseSource = responses[5];

            this.setState({
              tags: responseTags.data,
              users: responseUsers.data,
              // contacts: responseContacts.data,
              country_list: responseCountry.data,
              status_list: responseStatus.data,
              source_list: responseSource.data,
              advertising_list: responseAdvertising.data,
              loading: false,
            });
          } else {
            this.setState({
              tags: responseTags.data,
              users: responseUsers.data,
              advertising_list: responseAdvertising.data,
              // contacts: responseContacts.data,
              loading: false,
            });
          }
        })
      )
      .catch((errors) => {
        console.log(errors);
      });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.handleFormSubmit(
          values,
          e,
          this.props.requestType,
          this.props.match.params.leadID
        );
        console.log("Received values of form: ", values);
      }
    });
  };

  handleFormSubmit = async (values, event, requestType, leadID) => {
    const branch = localStorage.getItem("branch");
    let filtered_assigned_to = this.state.users.filter((item) => {
      if (values.assigned_to && values.assigned_to.includes(item.id))
        return true;
    });
    let filtered_tags = this.state.tags.filter((item) => {
      if (values.tags && values.tags.includes(item.slug)) return true;
    });
    let filtered_ads = this.state.advertising_list.filter((item) => {
      if (values.advertising && values.advertising.includes(item.id))
        return true;
    });
    // let filtered_contacts = this.state.contacts.filter(item => {
    //   if (values.contacts && values.contacts.includes(item.id))
    //     return true;
    // });
    let creation_of_business;
    if (event.target.elements.creation_of_business.value == "")
      creation_of_business = null;
    else
      creation_of_business = event.target.elements.creation_of_business.value;

    const postObj = {
      name: values.name,
      full_name: values.full_name,
      email: values.email,
      phone: values.phone,
      status: values.status,
      source: values.source,
      address: values.address,
      city: values.city,
      region_level_one: values.region_level_one,
      region_level_two: values.region_level_two,
      post_code: values.post_code,
      country: values.country,
      website: values.website,
      agency_website: values.agency_website,
      description: values.description,
      siret: values.siret,
      job: values.job,
      siren: values.siren,
      creation_of_business: creation_of_business,
      workforce: values.workforce,
      circulation: values.circulation,
      other_names: values.other_names,
      assigned_to: filtered_assigned_to,
      created_by: values.created_by,
      client_account: values.client_account,
      created_on: event.target.elements.created_on.value,
      is_active: values.is_active,
      tags: filtered_tags,
      contacts: values.contacts.map((e) => e.key),
      created_by_scrapping: values.created_by_scrapping,
      check_for_domain_expirity: values.check_for_domain_expirity,
      advertising: filtered_ads,
      local_seo: values.local_seo,
      natural_seo: values.natural_seo,
      keywords: values.keywords,
      proposal: values.proposal,
    };
    if (requestType === "post" && parseInt(branch))
      postObj.branch = parseInt(branch);

    if (requestType === "post") {
      await axios
        .post(process.env.REACT_APP_AXIOS_URL + "/api/leads/create/", postObj)
        .then((res) => {
          if (res.status === 201) {
            Lib.responseMessage("success", "Lead successfully created");
            this.props.history.push(`/leads`);
          }
        })
        .catch((err) => Lib.responseMessage("error", err.response.data));
    } else if (requestType === "put") {
      await axios
        .put(
          process.env.REACT_APP_AXIOS_URL + `/api/leads/${leadID}/update/`,
          postObj
        )
        .then((res) => {
          if (res.status === 200) {
            Lib.responseMessage(
              "success",
              `Successfully update lead ${values.name}`
            );
            this.props.history.push(`/leads`);
          }
        })
        .catch((err) => Lib.responseMessage("error", err.response.data));
    }
  };

  // handleDeselectContact = (contactID) => {
  //     // event.preventDefault();
  //     axios.delete(process.env.REACT_APP_AXIOS_URL + `/api/contacts/${contactID}/delete/`)
  //         .then(res => {
  //             if (res.status === 204 || res.status === 200) {
  //                 this.props.fetchSingle();
  //             }
  //         })
  // }

  render() {
    if (this.state.loading) {
      return (
        <div>
          <Skeleton active loading={this.state.loading} />
          <Skeleton active loading={this.state.loading} />
          <Skeleton active loading={this.state.loading} />
          <Skeleton active loading={this.state.loading} />
          <Skeleton active loading={this.state.loading} />
        </div>
      );
    } else {
      const [p] = [this.props];
      const { getFieldDecorator } = this.props.form;

      const { t } = this.props;

      let tags_filtered,
        users_filtered,
        contacts_filtered,
        ads_filtered = [];
      if (this.props.requestType === "put") {
        tags_filtered = this.props.data.tags.map((item) => {
          return item.slug;
        });
        users_filtered = this.props.data.assigned_to.map((item) => {
          return item.id;
        });
        contacts_filtered = this.props.data.contacts.map((item) => {
          return item.id;
        });
        ads_filtered = this.props.data.advertising.map((item) => {
          return item.id;
        });
      }

      let country_list;
      if (this.state.country_list == null)
        country_list = this.props.data.country_list;
      else country_list = this.state.country_list;

      let status_list;
      if (this.state.status_list == null)
        status_list = this.props.data.status_list;
      else status_list = this.state.status_list;

      let source_list;
      if (this.state.source_list == null)
        source_list = this.props.data.source_list;
      else source_list = this.state.source_list;

      let created_on;
      if (this.props.data.created_on)
        created_on = moment(this.props.data.created_on, dateFormat);
      else created_on = moment(new Date(), dateFormat);

      let creation_of_business;
      if (this.props.data.creation_of_business)
        creation_of_business = moment(
          this.props.data.creation_of_business,
          dateFormat
        );
      else creation_of_business = null;

      let is_active;
      if (this.props.data.is_active) is_active = this.props.data.is_active;
      else is_active = false;

      let clients, admins;
      clients = this.state.users.filter((item) => item.role === "USER");
      admins = this.state.users.filter((item) => item.role === "ADMIN");

      let contacts;
      contacts = this.props.contacts;

      return (
        <div>
          <Form
            layout="vertical"
            size="small"
            hideRequiredMark
            onSubmit={this.handleSubmit}
          >
            <p className="pStyle" style={{ marginBottom: 24 }}>
              {t("leads.lead_form.lead_info", "Lead information")}
            </p>
            <p className="pStyle">{t("leads.lead_form.company", "Company")}</p>
            <Row gutter={8}>
              <Col sm={12}>
                <FormItem
                  label={t("leads.lead_form.company_name", "Company name")}
                >
                  {getFieldDecorator("name", {
                    initialValue: this.props.data.name,
                    rules: [
                      {
                        required: true,
                        message: t(
                          "leads.lead_form.company_name_required",
                          "Company name is required!"
                        ),
                      },
                    ],
                  })(<Input name="name" />)}
                </FormItem>
              </Col>
              <Col sm={12}>
                <FormItem label={t("leads.lead_form.full_name", "Full name")}>
                  {getFieldDecorator("full_name", {
                    initialValue: this.props.data.full_name,
                    rules: [
                      {
                        // required: true, message: 'First name is required!'
                      },
                    ],
                  })(<Input name="full_name" />)}
                </FormItem>
              </Col>
            </Row>
            <Row gutter={8}>
              <Col sm={12}>
                <FormItem label={t("leads.lead_form.email", "Email")}>
                  {getFieldDecorator("email", {
                    initialValue: this.props.data.email,
                    rules: [
                      {
                        type: "email",
                        message: t(
                          "leads.lead_form.email_invalid",
                          "The input is not valid email!"
                        ),
                      },
                    ],
                  })(<Input name="email" />)}
                </FormItem>
              </Col>
              <Col sm={12}>
                <FormItem label={t("leads.lead_form.phone", "Phone")}>
                  {getFieldDecorator("phone", {
                    initialValue: this.props.data.phone,
                    rules: [{}],
                  })(<Input name="phone" />)}
                </FormItem>
              </Col>
            </Row>
            <Row gutter={8}>
              <Col sm={12}>
                <FormItem label={t("leads.lead_form.siret", "Siret")}>
                  {getFieldDecorator("siret", {
                    initialValue: this.props.data.siret,
                    rules: [
                      {
                        // required: true, message: 'Website is required!'
                      },
                    ],
                  })(<Input name="siret" />)}
                </FormItem>
              </Col>
            </Row>
            <Row gutter={8}>
              <Col sm={12}>
                <FormItem label={t("leads.lead_form.job", "Job")}>
                  {getFieldDecorator("job", {
                    initialValue: this.props.data.job,
                    rules: [
                      {
                        // required: true, message: 'Description is required!'
                      },
                    ],
                  })(<Input name="job" />)}
                </FormItem>
              </Col>
              <Col sm={12}>
                <FormItem label={t("leads.lead_form.siren", "Siren")}>
                  {getFieldDecorator("siren", {
                    initialValue: this.props.data.siren,
                    rules: [
                      {
                        // required: true, message: 'Website is required!'
                      },
                    ],
                  })(<Input name="siren" />)}
                </FormItem>
              </Col>
            </Row>
            <Row gutter={8}>
              <Col sm={12}>
                <FormItem
                  label={t(
                    "leads.lead_form.creation_of_business",
                    "Date of business creation"
                  )}
                >
                  {getFieldDecorator("creation_of_business", {
                    initialValue: creation_of_business,
                    rules: [
                      {
                        type: "object",
                        // required: true, message: 'Description is required!'
                      },
                    ],
                  })(
                    <DatePicker
                      name="creation_of_business"
                      format={dateFormat}
                    />
                  )}
                </FormItem>
              </Col>
              <Col sm={6}>
                <FormItem label={t("leads.lead_form.workforce", "Workforce")}>
                  {getFieldDecorator("workforce", {
                    initialValue: this.props.data.workforce,
                    rules: [
                      {
                        // required: true, message: 'Website is required!'
                      },
                    ],
                  })(<Input name="workforce" />)}
                </FormItem>
              </Col>
              <Col sm={6}>
                <FormItem
                  label={t("leads.lead_form.circulation", "Circulation")}
                >
                  {getFieldDecorator("circulation", {
                    initialValue: this.props.data.circulation,
                    rules: [
                      {
                        // required: true, message: 'Website is required!'
                      },
                    ],
                  })(<Input name="circulation" />)}
                </FormItem>
              </Col>
            </Row>
            <Row gutter={8}>
              <Col sm={12}>
                <FormItem
                  label={t("leads.lead_form.other_names", "Other names")}
                >
                  {getFieldDecorator("other_names", {
                    initialValue: this.props.data.other_names,
                    rules: [
                      {
                        // required: true, message: 'Description is required!'
                      },
                    ],
                  })(<Input name="other_names" />)}
                </FormItem>
              </Col>
              <Col sm={12}>
                <FormItem label={t("leads.lead_form.contacts", "Contacts")}>
                  {getFieldDecorator("contacts", {
                    initialValue: Lib.setSelectValueMultiple(
                      get(p.data, "contacts"),
                      "id",
                      "first_name"
                    ),
                    // rules: [{
                    //   type: 'array'
                    //   required: true, message: 'Website is required!'
                    // }],
                  })(
                    <SelectQuery
                      urlKey={`autocomplete-contacts`}
                      // paramProps={this.props.paramProps}
                      placeholder=""
                      token={localStorage.getItem("token")}
                      suffixIcon={<Icon type="caret-down" />}
                      valKey={"id"}
                      valLabel={"first_name"}
                      mode="multiple"
                      // style={{ maxWidth: '71%', marginRight: '10px' }}
                      // dropdownClassName={this.props.dropdownClassName} // untuk styling dropdown by class
                    />
                  )}
                </FormItem>
              </Col>
            </Row>
            <Row gutter={8}>
              <Col sm={12}>
                <FormItem
                  label={t("leads.lead_form.description", "Description")}
                >
                  {getFieldDecorator("description", {
                    initialValue: this.props.data.description,
                    rules: [
                      {
                        // required: true, message: 'Country is required!'
                      },
                    ],
                  })(<Input.TextArea name="description" />)}
                </FormItem>
              </Col>
              <Col sm={12}>
                <FormItem label={t("leads.lead_form.websites", "Websites")}>
                  {getFieldDecorator("website", {
                    initialValue: this.props.data.website,
                    rules: [
                      {
                        // required: true, message: 'Country is required!'
                      },
                    ],
                  })(<Input.TextArea name="website" />)}
                </FormItem>
              </Col>
              <Col sm={12}>
                <FormItem
                  label={t("leads.lead_form.agency_website", "Agency Website")}
                >
                  {getFieldDecorator("agency_website", {
                    initialValue: this.props.data.agency_website,
                    rules: [
                      {
                        // required: true, message: 'Country is required!'
                      },
                    ],
                  })(<Input.TextArea name="agency_website" />)}
                </FormItem>
              </Col>
            </Row>
            <Divider />
            <p className="pStyle">
              {t("leads.lead_form.location", "Location")}
            </p>
            <Row gutter={8}>
              <Col sm={12}>
                <FormItem label={t("leads.lead_form.address", "Address")}>
                  {getFieldDecorator("address", {
                    initialValue: this.props.data.address,
                    rules: [
                      {
                        // required: true, message: 'Lead source is required!'
                      },
                    ],
                  })(<Input name="address" />)}
                </FormItem>
              </Col>
              <Col sm={12}>
                <FormItem label={t("leads.lead_form.city", "City")}>
                  {getFieldDecorator("city", {
                    initialValue: this.props.data.city,
                    rules: [
                      {
                        // required: true, message: 'Address is required!'
                      },
                    ],
                  })(<Input name="city" />)}
                </FormItem>
              </Col>
            </Row>
            <Row gutter={8}>
              <Col sm={12}>
                <FormItem
                  label={t(
                    "leads.lead_form.region_level_one",
                    "Region level one"
                  )}
                >
                  {getFieldDecorator("region_level_one", {
                    initialValue: this.props.data.region_level_one,
                    rules: [
                      {
                        // required: true, message: 'Street is required!'
                      },
                    ],
                  })(<Input name="region_level_one" />)}
                </FormItem>
              </Col>
              <Col sm={12}>
                <FormItem
                  label={t(
                    "leads.lead_form.region_level_two",
                    "Region level two"
                  )}
                >
                  {getFieldDecorator("region_level_two", {
                    initialValue: this.props.data.region_level_two,
                    rules: [
                      {
                        // required: true, message: 'City is required!'
                      },
                    ],
                  })(<Input name="region_level_two" />)}
                </FormItem>
              </Col>
            </Row>
            <Row gutter={8}>
              <Col sm={12}>
                <FormItem label={t("leads.lead_form.post_code", "Post code")}>
                  {getFieldDecorator("post_code", {
                    initialValue: this.props.data.post_code,
                    rules: [
                      {
                        // required: true, message: 'Region is required!'
                      },
                    ],
                  })(<Input name="post_code" />)}
                </FormItem>
              </Col>
              <Col sm={12}>
                <FormItem label={t("leads.lead_form.country", "Country")}>
                  {getFieldDecorator("country", {
                    initialValue: this.props.data.country,
                    rules: [
                      {
                        // required: true, message: 'Postcode is required!'
                      },
                    ],
                  })(
                    <Select
                      showSearch
                      name="country"
                      placeholder={t(
                        "leads.lead_form.country_select",
                        "Select country"
                      )}
                    >
                      {country_list.map((item) => (
                        <Option key={item[0]} value={item[0]}>
                          {item[1]}
                        </Option>
                      ))}
                    </Select>
                  )}
                </FormItem>
              </Col>
            </Row>
            <Divider />
            <p className="pStyle">
              {t("leads.lead_form.business_analysis", "Business analysis")}
            </p>
            <Row gutter={8}>
              <Col sm={12}>
                <FormItem
                  label={t("leads.lead_form.natural_seo", "Natural SEO")}
                  placeholder={t(
                    "leads.lead_form.natural_seo_placeholder",
                    "SERP position, SEO titles, blogs, performance"
                  )}
                >
                  {getFieldDecorator("natural_seo", {
                    initialValue: this.props.data.natural_seo,
                    rules: [
                      {
                        // required: true, message: 'Country is required!'
                      },
                    ],
                  })(<Input.TextArea name="natural_seo" />)}
                </FormItem>
              </Col>
              <Col sm={12}>
                <FormItem label={t("leads.lead_form.local_seo", "Local SEO")}>
                  {getFieldDecorator("local_seo", {
                    initialValue: this.props.data.local_seo,
                    rules: [
                      {
                        // required: true, message: 'Country is required!'
                      },
                    ],
                  })(<Input name="local_seo" />)}
                </FormItem>
              </Col>
            </Row>
            <Row gutter={8}>
              <Col sm={12}>
                <FormItem
                  label={t("leads.lead_form.advertising", "Advertising")}
                >
                  {getFieldDecorator("advertising", {
                    initialValue: ads_filtered,
                    rules: [
                      {
                        type: "array",
                      },
                    ],
                  })(
                    <Select name="advertising" mode="multiple">
                      {this.state.advertising_list.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.name}
                        </Option>
                      ))}
                    </Select>
                  )}
                </FormItem>
              </Col>
              <Col sm={12}>
                <FormItem label={t("leads.lead_form.keywords", "Keywords")}>
                  {getFieldDecorator("keywords", {
                    initialValue: this.props.data.keywords,
                    rules: [
                      {
                        // required: true, message: 'Country is required!'
                      },
                    ],
                  })(<Input.TextArea name="keywords" />)}
                </FormItem>
              </Col>
            </Row>
            <Row gutter={8}>
              <Col sm={12}>
                <FormItem label={t("leads.lead_form.proposal", "Proposal")}>
                  {getFieldDecorator("proposal", {
                    initialValue: this.props.data.proposal,
                    rules: [
                      {
                        // required: true, message: 'Country is required!'
                      },
                    ],
                  })(<Input name="proposal" />)}
                </FormItem>
              </Col>
            </Row>
            {/*  */}
            <Divider />
            <p className="pStyle">
              {t("leads.lead_form.extra_info", "Extra information")}
            </p>
            <Row gutter={8}>
              <Col sm={12}>
                <FormItem label={t("leads.lead_form.status", "Status of lead")}>
                  {getFieldDecorator("status", {
                    initialValue: this.props.data.status,
                    rules: [
                      {
                        // required: true, message: 'Phone number is required!'
                      },
                    ],
                  })(
                    <Select
                      name="status"
                      placeholder={t(
                        "leads.lead_form.status_lead",
                        "Select status of lead"
                      )}
                    >
                      {status_list.map((item) => (
                        <Option key={item[0]} value={item[0]}>
                          {item[1]}
                        </Option>
                      ))}
                    </Select>
                  )}
                </FormItem>
              </Col>
              <Col sm={12}>
                <FormItem label={t("leads.lead_form.source", "Source of lead")}>
                  {getFieldDecorator("source", {
                    initialValue: this.props.data.source,
                    rules: [
                      {
                        // required: true, message: 'Status is required!'
                      },
                    ],
                  })(
                    <Select
                      name="source"
                      placeholder={t(
                        "leads.lead_form.source_select",
                        "Select source of lead"
                      )}
                    >
                      {source_list.map((item) => (
                        <Option key={item[0]} value={item[0]}>
                          {item[1]}
                        </Option>
                      ))}
                    </Select>
                  )}
                </FormItem>
              </Col>
            </Row>
            <Row gutter={8}>
              <Col sm={12}>
                <FormItem
                  label={t("leads.lead_form.assigned_to", "Assigned to")}
                >
                  {getFieldDecorator("assigned_to", {
                    initialValue: users_filtered,
                    rules: [
                      {
                        type: "array",
                        // required: true, message: 'Phone number is required!'
                      },
                    ],
                  })(
                    <Select
                      mode="multiple"
                      name="assigned_to"
                      placeholder={t(
                        "leads.lead_form.assigned_to_select",
                        "Select users"
                      )}
                    >
                      {admins.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.first_name} {item.last_name}{" "}
                          {!item.first_name && !item.last_name && "No Name"}
                        </Option>
                      ))}
                    </Select>
                    // <Input name="assigned_to" />
                  )}
                </FormItem>
              </Col>
              <Col sm={6}>
                <FormItem label={t("leads.lead_form.created_by", "Created by")}>
                  {getFieldDecorator("created_by", {
                    initialValue: this.props.data.created_by
                      ? this.props.data.created_by
                      : undefined,
                    rules: [
                      {
                        type: "number",
                        // required: true, message: 'Status is required!'
                      },
                    ],
                  })(
                    <Select
                      name="created_by"
                      placeholder={t(
                        "leads.lead_form.created_by_select",
                        "Select user"
                      )}
                    >
                      {admins.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.first_name} {item.last_name}
                        </Option>
                      ))}
                    </Select>
                  )}
                </FormItem>
              </Col>
              <Col sm={6}>
                <FormItem
                  label={t("leads.lead_form.client_account", "Client user")}
                >
                  {getFieldDecorator("client_account", {
                    initialValue: this.props.data.client_account
                      ? this.props.data.client_account
                      : undefined,
                    rules: [
                      {
                        type: "number",
                        // required: true, message: t('leads.lead_form.client_account_required', "Client user is required to choose!")
                      },
                    ],
                  })(
                    <Select
                      name="client_account"
                      placeholder={t(
                        "leads.lead_form.client_account_select",
                        "Select user"
                      )}
                    >
                      {clients.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.first_name} {item.last_name}
                        </Option>
                      ))}
                    </Select>
                  )}
                </FormItem>
              </Col>
            </Row>
            <Row gutter={8}>
              <Col sm={12}>
                <FormItem label={t("leads.lead_form.created_on", "Created on")}>
                  {getFieldDecorator("created_on", {
                    initialValue: created_on,
                    rules: [
                      {
                        type: "object",
                        // required: true, message: 'Phone number is required!'
                      },
                    ],
                  })(
                    <DatePicker
                      disabled
                      name="created_on"
                      format={dateFormat}
                      disabled
                    />
                  )}
                </FormItem>
              </Col>
              <Col sm={12}>
                <FormItem label={t("leads.lead_form.is_active", "Is active?")}>
                  {getFieldDecorator("is_active", {
                    // initialValue: is_active,
                    rules: [
                      {
                        type: "boolean",
                        // required: true, message: 'Status is required!'
                      },
                    ],
                  })(
                    <Switch
                      defaultChecked={this.props.data.is_active}
                      name="is_active"
                    />
                  )}
                </FormItem>
              </Col>
            </Row>
            <Row gutter={8}>
              <Col sm={12}>
                <FormItem label={t("leads.lead_form.tags", "Tags")}>
                  {getFieldDecorator("tags", {
                    initialValue: tags_filtered,
                    rules: [
                      {
                        type: "array",
                      },
                    ],
                  })(
                    <Select
                      mode="multiple"
                      name="tags"
                      placeholder={t(
                        "leads.lead_form.tags_select",
                        "Select tags"
                      )}
                    >
                      {this.state.tags.map((item) => (
                        <Option key={item.slug} value={item.slug}>
                          {item.name}
                        </Option>
                      ))}
                    </Select>
                  )}
                </FormItem>
              </Col>
              <Col sm={12}>
                <FormItem
                  label={t(
                    "leads.lead_form.created_by_scraping",
                    "Created by scraping"
                  )}
                >
                  {getFieldDecorator("created_by_scrapping", {
                    rules: [
                      {
                        type: "boolean",
                        // required: true, message: 'Status is required!'
                      },
                    ],
                  })(
                    <Switch
                      defaultChecked={this.props.data.created_by_scrapping}
                      name="created_by_scrapping"
                    />
                  )}
                </FormItem>
              </Col>
            </Row>
            <Row gutter={8}>
              <Col sm={12}></Col>
              <Col sm={12}>
                <FormItem
                  label={t(
                    "leads.lead_form.check_for_domain",
                    "Check for domain expirity?"
                  )}
                >
                  {getFieldDecorator("check_for_domain_expirity", {
                    rules: [
                      {
                        type: "boolean",
                        // required: true, message: 'Status is required!'
                      },
                    ],
                  })(
                    <Switch
                      defaultChecked={this.props.data.check_for_domain_expirity}
                      name="check_for_domain_expirity"
                    />
                  )}
                </FormItem>
              </Col>
            </Row>

            <FormItem>
              <Button type="primary" htmlType="submit">
                {this.props.btnText}
              </Button>
              {/* {
                                this.props.requestType === 'put'
                                    ?
                                    <Button type="danger" style={{ marginLeft: 8 }} onClick={this.handleDelete}>
                                        {t('general.delete', "Delete")}
                                    </Button>
                                    :
                                    ''
                            } */}
            </FormItem>
          </Form>
        </div>
      );
    }
  }
}

const LeadForm = Form.create()(withTranslation()(LeadFormInit));

export default withRouter(LeadForm);



// WEBPACK FOOTER //
// ./src/containers/Leads/LeadForm.js